module.exports = __webpack_public_path__ + "img/horizontal_3_2_r_pp2_8004.cdb26c6b.png";